import React from 'react';
import BotTableContainer from '../containers/bot-table.container';
import BotDetailsContainer from '../containers/bot-details.container';
import BotCreateContainer from '../containers/bot-create.container';
import BotUpdateContainer from '../containers/bot-update.container';
import TenantGuard from '@components/common/TenantGuard';

export const botRoutes = [
  {
    path: 'bots',
    element: (
      <TenantGuard showHeader={true} headerTitle="Bots" showBreadcrumbs={true}>
        <BotTableContainer />
      </TenantGuard>
    ),
  },
  {
    path: 'bots/create',
    element: (
      <TenantGuard showHeader={true} headerTitle="Create Bot" showBreadcrumbs={true}>
        <BotCreateContainer />
      </TenantGuard>
    ),
  },
  {
    path: 'bots/:id/update',
    element: (
      <TenantGuard showHeader={true} headerTitle="Update Bot" showBreadcrumbs={true}>
        <BotUpdateContainer />
      </TenantGuard>
    ),
  },
  {
    path: 'bots/:id',
    element: (
      <TenantGuard showHeader={true} headerTitle="Bot Details" showBreadcrumbs={true}>
        <BotDetailsContainer />
      </TenantGuard>
    ),
  },
];

export default botRoutes;
